<template>
	<div class="container_t_padding clearfix">
		<div class="about_banner">
			<div class="banner_text">
				<p>为经纪人服务的全渠道合作软件</p>
			</div>
		</div>
		<div class="subject_box clearfix">
			<div class="about_content clearfix">
				<img src="../../assets/about_title_img.png"/>
				<div class="about_item clearfix">
					<p>北京芒果铭天科技有限公司成立于2018年6月1日，是一家以赋能营销为主的互联网+房地产公司。公司作为国家高新技术企业，以高科技创新技术为核心，以“强销模式”、“智慧营销”为载体，通过“大数据挖掘”、“智能AI营销”、“3DVR展销”等新兴技术，着力打造开发商、经纪公司、经纪人以及客户间的多角色多平台联动。
					<br/>公司推出“蜗牛哥”品牌，自主开发蜗牛哥PC端、客户端、经纪人端及多款小程序，构建线上只能营销体系。主打全渠道获客，实现房产私域流量池。创建SCRM营销自动化系统，让获客转化更简单，衡量优化营销ROI，提升业绩级业界口碑。垂直打通购房服务体系中的上下游链路，统一提供新房地产交易的综合服务。
					</p>
					<img src="../../assets/about_img1.png" class="img" />
				</div>
			</div>
			<img src="../../assets/about_content_img2.png" />
			<img src="../../assets/about_content_img3.png" />
			<img src="../../assets/about_content_img4.png" />
			<img src="../../assets/about_content_img5.png" />
			<img src="../../assets/about_content_img6.png" />
			<div id="map" style="width:1200px;height:350px;margin-bottom: 40px;"></div>
		</div>
	</div>
</template>

<script>
	export default{
		mounted() {
			// 百度地图API功能
			var map = new BMapGL.Map("map");
			var point = new BMapGL.Point(116.564983,39.904083)
			map.centerAndZoom(point, 15);
			map.enableScrollWheelZoom(true);
			
			var icon = new BMapGL.Icon('/map.png',new BMapGL.Size(33,40));
			var mk = new BMapGL.Marker(point,{icon:icon});
			map.addOverlay(mk);
			
			var opts = {
			    width: 200,
			    height: 80,
			    title: '电话：400-632-8866'
			};
			var infoWindow = new BMapGL.InfoWindow('地址：北京市朝阳区高碑店乡北花园村南3-1FC0号楼523室',opts);
			map.openInfoWindow(infoWindow, point);
		},
		metaInfo: {
			title: '关于芒果科技_专业的经纪人营销拓客工具提供商蜗牛哥', // set a title
			meta: [{             // set meta
			  name: 'keyWords',
			  content: '关于芒果科技,蜗牛哥经纪人,企业荣誉,企业资质,发展历程,合作企业,联系我们'
			},
			{
			  name: 'description',
			  content: '关于我们是芒果科技蜗牛哥经纪人平台的企业介绍和经纪人营销拓客工具企业合作方式'
			}]
		}
	}
</script>

<style lang="less">
	// 关于我们
	.about_content {
		padding: 50px 0 0 0;
		.about_item {
			margin-top: 34px;
			p {
				font-size: 14px; color:#333; line-height: 28px; width: 712px; float: left;
			}
			.img {
				float: right;
			}
		}
	}
	.BMap_cpyCtrl {
		display: none;
	}
	.anchorBL {
		display: none;
	}
	.BMap_bubble_buttons {
		display: none !important;
	}
	.about_banner {
		min-width: 1200px; height: 328px; background: url(../../assets/about_banner_img.jpg) top center no-repeat;
		.banner_text {
			width: 1200px; margin: 0 auto; height: 328px; position: relative; overflow: hidden;
			p {
				font-size: 32px; color: #fff; line-height: 1; letter-spacing: 2px; text-align: center; margin-top: 138px; position: relative;
				&::after {
					content: ''; width: 74px; height: 4px; background: #fff; position: absolute; left: 0; right: 0; bottom: -20px; margin: 0 auto;
				}
			}
		}
	}
	.subject_box {
		width: 1200px; margin: 0 auto;
	}
</style>
